import React from 'react'
import { Link } from 'react-router-dom'
import { TeamData } from '../data'

export default function TeamOne() {
  return (
        <div className="row justify-content-center">
            {TeamData.map((item,index)=>{
                return(
                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                        <div className="mt-4 pt-2">
                            <div className="team position-relative d-block text-center">
                                <div className="image position-relative d-block overflow-hidden">
                                    <img src={item.image} className="rounded" style={{maxWidth:'60%'}} alt=""/>
                                    <div className="overlay rounded"></div>
                                </div>
                                <div className="content py-2 member-position bg-white border-bottom overflow-hidden rounded d-inline-block">
                                    <h4 className="title mb-0">{item.name}</h4>
                                    <small className="text-muted">{item.position}</small>
                                </div>                                
                            </div>
                        </div>
                    </div>
                )
            })}

            
        </div>
  )
}
